import { InputAdornment } from "@mui/material";

const halfDayEndAdornment = {
  InputProps: {
    endAdornment: (
      <InputAdornment position="end" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}>
        1/2 day
      </InputAdornment>
    ),
  },
};

export default halfDayEndAdornment;
